import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { captureInboundPayload } from './lib/inbound';
import { captureSharedLaunch } from './lib/shareTarget';
import { requestPersistentStorage } from './lib/storageHealth';
import { refreshCustomCss } from './lib/customCss';

// The service worker is registered by <PwaPrompt> (virtual:pwa-register/react),
// which also surfaces the "update available" + "install app" prompts.

// Shared preview base for rendered output. (KaTeX CSS is lazy-loaded with the
// KaTeX runtime in lib/katex.ts, only when a document contains math.)
import '@markbird/markdown/styles.css';
// Brand design system (order matters — tokens are the source of truth, then
// self-hosted fonts, base theme, and reader-preview styling). See packages/brand.
import './styles/tokens.css';
import './styles/fonts.css';
import './styles/theme.css';
import './styles/preview.css';
// Bridge legacy component variable names -> brand tokens (see bridge.css).
import './styles/bridge.css';
// App shell / component styles (consume the bridged brand tokens).
import './styles/app.css';

// A `/new#<payload>` launch carries a document from outside (the browser
// extension, the MCP server). Take it off the URL before React mounts — see
// captureInboundPayload() for why this cannot wait for an effect.
// Ask the browser to keep the library rather than treating it as a cache it may
// reclaim. Installed and well-used apps are granted this silently; elsewhere the
// answer is shown in Settings, where it can be asked for inside a click.
void requestPersistentStorage();
// Your own CSS, before the first paint where possible.
void refreshCustomCss();
captureInboundPayload();
captureSharedLaunch();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
